import { Grid, Paper } from "@mui/material";

import NavBarItem from "./NavBarItem";
import dashboardItems from "../../sidebar/dashboardItems";
import { styled } from "@mui/system";
import { isMenuItemVisible } from "../../../utils/authTools";
import useAuth from "../../../hooks/useAuth";

const PaperContainer = styled(Paper)`
  min-width: 21rem;
  width: 100vw;
  position: fixed;
  left: 0;
  z-index: 100;
  bottom: 0;
  padding: ${(props) => props.theme.spacing(2)};
  background-color: ${(props) => props.theme.palette.background.default};
  background-image: none;
  border-radius: ${(props) =>
    `${props.theme.shape.borderRadiusMobileNav}px ${props.theme.shape.borderRadiusMobileNav}px 0 0`};
`;

const GridContainer = styled(Grid)``;

const MobileNavBar = ({ showFooter = true, test, ...rest }) => {
  const items = dashboardItems;
  const [{ state }] = useAuth();
  const { routes } = state;
  return (
    <PaperContainer
      elevation={16}
      sx={{ display: { xs: "block", md: "none" } }}
    >
      <GridContainer
        elevation={12}
        container
        spacing={0}
        justifyContent="center"
        flexWrap="nowrap"
        sx={{ minWidth: "19rem" }}
      >
        {items?.[0]?.pages
          ?.filter(
            (page) => page?.mobile && isMenuItemVisible(page?.title, routes)
          )
          .map((page) => (
            <Grid item key={page.title} xs>
              <NavBarItem item={page} test />
            </Grid>
          ))}
      </GridContainer>
    </PaperContainer>
  );
};

export default MobileNavBar;
